<template>
  <div v-bind:class="{ 'version-spacing': !isLoggedIn }">
    <PageHeader title="Change Password"></PageHeader>
      <v-container class="page-bottom">
        <v-row>
          <v-col>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="validate"
            >
              <v-text-field
                v-model="user.oldPassword"
                :rules="[rules.required]"
                :type="showOldPass ? 'text' : 'password'"
                label="Old Password"
                autocomplete="on"
              >
                <v-icon slot="append" color="white" @click="showOldPass = !showOldPass">
                  {{showOldPass ? 'mdi-eye' : 'mdi-eye-off'}}
                </v-icon>
              </v-text-field>

              <v-text-field
                v-model="user.newPassword"
                :rules="[rules.required]"
                :type="showNewPass ? 'text' : 'password'"
                label="New Password"
                autocomplete="on"
              >
                <v-icon slot="append" color="white" @click="showNewPass = !showNewPass">
                  {{showNewPass ? 'mdi-eye' : 'mdi-eye-off'}}
                </v-icon>
              </v-text-field>

              <v-btn
                block
                outlined
                large
                style="color: #ffffff !important;border: 1px solid #ffb300;"
                :disabled="!valid"
                color="success"
                class="mt-5"
                type="submit"
              >
                Save
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <router-link :to="{name: 'profile'}">Back to profile</router-link>
          </v-col>
        </v-row>
      </v-container>

    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      centered
      color="error"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>      
    <Spinner :overlay="overlay"></Spinner>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import Spinner from './../../components/Spinner';
import UserPool from "../../plugins/UserPool";

export default {
  name: 'changepassword',
  components: {
    PageHeader,
    Spinner
  },
  data: () => ({
    valid: true,
    user: {
      oldPassword: '',
      newPassword: '',
      userName: null
    },
    keepLoggedIn: false,
    rules: {
      required: value => !!value || 'Required.'
    },
    overlay: false,
    absolute: true,
    snackbar: false,
    snackbarText: '',
    showOldPass: false,
    showNewPass: false
  }),
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    validate () {
      var scope = this;
      var isValid = scope.$refs.form.validate();
      if(isValid){
        scope.overlay = true;
        scope.login();
      }
    },
    login () {
      var scope = this;
      scope.overlay = true;

      var cognitoUser = UserPool.getCurrentUser();
      
      cognitoUser.getSession(function(error, session) {
        if(error) {
          console.log(error);
          return;
        }

        if(session) {

          cognitoUser.changePassword(scope.user.oldPassword, scope.user.newPassword, function (err, result) {
              if(err) {
                console.log("onFailure: ", err);
                scope.overlay = false;
                scope.snackbarText = err.message;
                scope.snackbar = true;
              } else {
                console.log(result);
                scope.overlay = false;
                scope.$router.push({name: 'profile', query: {passwordChanged: true}});
              }
          });
          
        }
      });
    }
  },
  created () {
    this.$store.commit('setShowSlideMenu', '');
    this.user.userName = this.$store.user
  }
}
</script>